import { render } from "./ListProducts.vue?vue&type=template&id=96dd82d4"
import script from "./ListProducts.vue?vue&type=script&lang=js"
export * from "./ListProducts.vue?vue&type=script&lang=js"

import "./ListProducts.vue?vue&type=style&index=0&id=96dd82d4&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__